import './styles.scss'
import 'lazysizes'
import { initWhenPageIsLoaded } from '@glidecms/deliver-core-dev/utilities'

// TODO: ServiceWorker needs to be loaded from the same origin, it cant be read
// from s3 as  other static assets can
if (process.env.ENVIRONMENT !== 'local' && 'serviceWorker' in navigator) {
  initWhenPageIsLoaded(() =>
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration)
      })
      .catch((registrationError: DOMException) => {
        console.error('SW registration failed: ', registrationError, {
          message: registrationError.message,
          code: registrationError.code,
          name: registrationError.name,
        })
      })
  )
}
